<template>
  <div>
    <div style="font-size: 12px;">
        <div v-if="!quickView" style="width: 100%; text-align: left; margin-top: 0px; display: flex; flex-direction: row; justify-content: space-between; align-items: space-between;">
            <h2>Production List</h2>        
            <!--<el-button 
                style="width: 100px; height: 30px;"
                type="primary"
                @click="createDeliveryReceipt"
                v-if="$store.getters.getSaleMasterDataProps.id>0 && $store.getters.getSaleMasterDataProps.sale_type === 1" 
                :loading="$store.getters.getLoadingState" 
                size="small">Deliver Items</el-button>-->
        
        
        </div>
        
        <div v-if="$store.getters.getProductionWorkOrderAutocompleteList.length>0" style="display: flex; flex-direction: column;">
        <el-input @focus="$event.target.select()"
            placeholder="Search..."
            size="small"
            clearable
            style="width: 250px; text-align: left;"
            v-model="search_term">
        </el-input>

        <el-table
            :default-sort = "{prop: 'order_sl_no', order: 'ascending'}"
            :data="$store.getters.getProductionWorkOrderAutocompleteList
                .filter(t => (t.work_order_number !== null && t.work_order_number.toLowerCase().match(search_term.toLowerCase())) || (t.process_name !== null && t.process_name.toLowerCase().match(search_term.toLowerCase())))"
            style="width: 100%">
          <el-table-column 
            
            prop="work_order_number"
            label="Work-Order#">
          </el-table-column>
          <el-table-column 
            label="Promise" align="center">
            <template slot-scope="scope">
                <div>
                    <span>
                    {{scope.row.appointment_date_changed}} {{scope.row.appointment_type === 0 ? '(D)' : '(T)'}}
                    <span v-if="scope.row.trial_name.length>0">
                        <br>{{scope.row.trial_name}}
                    </span>
                    </span>
                </div>
            </template>
          </el-table-column>
          <el-table-column 
            
            label="Garment">
            <template slot-scope="scope">
                <!--{{scope.row.id}}<br>-->
                {{scope.row.sub_sub_category_id !== null ? scope.row.sub_template_name+' ('+scope.row.template_name+')' : scope.row.template_name}}
            </template>
          </el-table-column>
          <el-table-column 
            label="Fabric" align="center">
            <template slot-scope="scope">
                <div>
                    <span>
                    {{scope.row.sku_code}}, {{scope.row.article_name}}
                    </span>
                </div>
            </template>
          </el-table-column>
          <el-table-column 
            
            label="Current Location">
            <template slot-scope="scope">
                {{scope.row.locality_name}}
            </template>
          </el-table-column>
          <el-table-column 
            
            label="Measured By">
            <template slot-scope="scope">
                {{scope.row.measurement_by_staff_name}}
            </template>
          </el-table-column>
          <el-table-column 
            
            prop="process_name"
            label="Current Status">
            <template slot-scope="scope">
                <el-link @click="loadProductionWorkHistory(scope.row)">
                    {{scope.row.process_name+' '+(scope.row.hidden_process === -1 ? scope.row.work_order_status : '')}}
                </el-link>
                
            </template>
          </el-table-column>
          
          <el-table-column 
            label="Labour Paid?" align="center" v-if="!calendar_source">
            <template slot-scope="scope">
                <div v-if="scope.row.payroll_id !== null && scope.row.payroll_id >0">
                    <span>
                        Yes (#{{scope.row.payroll_number}})
                    </span>
                </div>
            </template>
          </el-table-column>
          <el-table-column 
            label="Delivered?" align="center" v-if="!calendar_source">
            <template slot-scope="scope">
                <div v-if="scope.row.production_id !== null">
                    <span>
                        Yes
                    </span>
                </div>
            </template>
          </el-table-column>
          <el-table-column 
            label="Delivery#" align="center" v-if="!calendar_source">
            <template slot-scope="scope">
                <div v-if="scope.row.production_id !== null">
                    <span>
                        #: {{scope.row.challan_number}}
                    </span>
                </div>
            </template>
          </el-table-column>
          <el-table-column 
            label="Delivery Date" align="right" v-if="!calendar_source">
            <template slot-scope="scope">
                <div v-if="scope.row.production_id !== null">
                    <span>
                        {{scope.row.challan_date_changed_time}}
                    </span>
                </div>
            </template>
          </el-table-column>          
          <el-table-column 
            v-if="!allow_delivery && !quickView"
            label="Put On Hold?" align="center">
            <template slot-scope="scope">
                <div v-if="!scope.row.production_id !== null" style="display: flex; flex-direction: row; justify-content: center; align-items: center;">
                    
                    <el-checkbox v-model="scope.row.on_hold">
                        YES
                    </el-checkbox>
                    <el-input @focus="$event.target.select()"
                        v-if="scope.row.on_hold"
                        size="small"
                        placeholder="Remarks..."
                        style="width: 200px;margin-left: 5px;"
                        v-model="scope.row.on_hold_remarks">
                    </el-input>
                    
                </div>
            </template>
          </el-table-column>
          <el-table-column 
            fixed="right"
            v-else-if="!payroll && !calendar_source"
            label="Convert To Inventory" align="center">
            <template slot-scope="scope">
                <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
                    
                    <el-button v-if="!scope.row.inventory_converted" @click="convertToInventory(scope.row)"  size="small" type="primary">
                        Convert
                    </el-button>

                    <el-button style="margin-top: 10px;" @click="issueRawMaterials(scope.row)"  size="small" type="primary">
                        Issue Materials
                    </el-button>
                </div>
                
            </template>
          </el-table-column>
            
        </el-table>
        </div>
        <div v-else style="width: 100%; text-align: center;">
            No Data
        </div>
        <div v-if="!allow_delivery && !quickView" style="width: 100%; text-align: left; margin-top: 20px; display: flex; flex-direction: row; justify-content: flex-end; align-items: flex-end;">
            <!--<el-button 
                size="small" 
                type="primary" 
                @click="confirmDelivery" 
                v-if="getDeliveryItemList.length>0" 
                style="height: 30px;">
                    Deliver {{getDeliveryItemList.length}} Items
            </el-button>-->
            <!-- && getItemList.filter((element) => element.on_hold).length>0 {{getItemList.filter((element) => element.on_hold).length}}-->
            <el-button 
                @click="confirmOnHold"
                v-if="!allow_delivery" 
                type="primary" size="small">Hold/Un-Hold Items</el-button>            
            
        </div>

    </div>
    <el-dialog
            :title="getProductionTitle"
            v-if="show_assignment_history"
            fullscreen
            :visible.sync="show_assignment_history"
            append-to-body>
                <WorkOrderAssignmentHistory   
                    :production_id="getSelectedProductionId"                 
                    @closed="show_assignment_history = false"/>
        </el-dialog>

        <el-dialog
            v-if="show_item_issue_window"
            fullscreen
            :title="getProductionTitle"
            :visible.sync="show_item_issue_window"
            append-to-body
            :show-close="false">
            <ProductionItemIssue 
                :rowData="getSelectedRowData"
                @closed="show_item_issue_window = false"/>
        </el-dialog>
  </div>
</template>

<script>
import WorkOrderAssignmentHistory from '../Production/WorkOrderAssignmentHistory'
import ProductionItemIssue from '../ProductionItemIssue/Index.vue'

export default {
    props: ['sale_id', 'sale_item_id', 'allow_delivery', 'quickView', 'payroll', 'calendar_source'],
    components: {ProductionItemIssue, WorkOrderAssignmentHistory},
    data() {
        return {
            delivery_item_list: [],
            master_payload: null,
            search_term: '',
            production_title: '',
            show_assignment_history: false,
            production_id: 0,
            show_item_issue_window: false,
            selected_row: null
        }
    },
    computed: {
        getSelectedRowData() {
            return this.selected_row
        },
        getSelectedProductionId() {
            return this.production_id
        },
        getProductionTitle() {
            return this.production_title
        },
        getDeliveryItemList() {
            return this.delivery_item_list
        },
        getItemList() {
            let list = this.$store.getters.getProductionWorkOrderAutocompleteList

            let returnList = []

            list.forEach(element => {
                if(this.allow_delivery && element.production_id === null) {
                    returnList.push(element)
                } else {
                    returnList.push(element)
                }
            })
            return returnList
        }  
    },
    methods: {
        convertToInventory(rowData) {
            this.$confirm('Are you sure to convert?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.$store.dispatch('convertToInventory', rowData)

                setTimeout(() => {
                    rowData.inventory_converted = true
                }, 1000);
            }).catch(() => {
                    
            });
        },
        loadProductionWorkHistory(rowData) {
            this.production_title = rowData.work_order_number
            this.production_id = rowData.id
            this.show_assignment_history = true            
        },
        deliver(rowData, hasItemIndex) {
            if(hasItemIndex>=0) {
                this.delivery_item_list.splice(hasItemIndex, 1)
            } else {
                this.delivery_item_list.push(rowData)
            }
            
        },
        confirmOnHold() {

            if(this.getItemList.filter((element) => element.on_hold && element.on_hold_remarks === null).length>0) {
                this.$store.commit('displayMessageAlert', {message: 'Please provide remarks for on-hold items', type: 'Error'})    
                return
            }

            this.$confirm('Are you sure to proceed?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.$store.dispatch('putProductionOrderOnHold', {master_payload: this.master_payload, item_list: this.getItemList})
            }).catch(() => {
                    
            });
        },
        async createDeliveryReceipt() {
            this.$store.commit('resetSaleDeliveryData')
            this.$store.state.saleDelivery.props.customer_id = this.$store.getters.getSaleMasterDataProps.customer_id
            
            await this.$store.dispatch('fetchCustomerMasterAutocompleteList', {load_delivery_receipt: true, customer_id: this.$store.getters.getSaleMasterDataProps.customer_id})
            
            this.$store.commit('appendBreadcrumbs', {
              crumbName: 'Delivery Receipts'
            })

            this.$emit('closed')
            
        },
        issueRawMaterials(rowData) {
            if(this.checkIfModuleAccessAvailable('/issuerawmaterials', 'can_add')) {
                this.selected_row = {
                    work_order_number: rowData.work_order_number,
                    id: rowData.id,
                    tailoring_item_id: rowData.tailoring_item_id,
                }
                this.show_item_issue_window = true
            }
        }
    },
    mounted() {
        this.$store.commit('resetProductionAutoCompleteList')
        setTimeout(() => {
            this.master_payload = {
                show_all: true, 
                sale_item_id: this.sale_item_id, 
                sale_id: this.sale_id,
                store_list: this.$store.getters.getAccessibleStoreList,
                no_limit: true
            }
            this.$store.dispatch('fetchProductionWorkOrderAutocompleteList', this.master_payload)
        }, 200);        
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/WorkOrder/ProductionList.vue